import {get, isNotUndefined, map, pipe} from '@yandex-delivery/utils'

import type {Order, PointID} from 'src/shared/types'

export function getOrderPointsIds(order?: Order): PointID[] {
  const sourceID = get('sourcePoint._id', order)
  const destinationsIDs = pipe(order, get('destinationPoints'), map(get('_id')))

  return [sourceID, ...destinationsIDs].filter(isNotUndefined)
}
